import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=5b077ee8&"
import script from "./AccountMenu.vue?vue&type=script&lang=ts&"
export * from "./AccountMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AccountMenu.vue?vue&type=style&index=0&id=5b077ee8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VIcon,VMenu,VTooltip,VWindow,VWindowItem})
